<template>
  <div class="box">
    <div class="container">
      <div class="content">
        <div class="txt-box" id="txt-b">
          <h1>
            <i>TO {{ $t('组委会') }}</i>
          </h1>
          <h2>{{ $t('提供全项目&全赛制，一站式办赛服务支撑') }}</h2>
          <div style="margin-top:40px;width: 1000px;">
            <p>
              {{
                $t('以智能竞赛系统+竞赛设备双引擎，为国家体育总局、教育部、各省市体育协会、学校、俱乐部等办赛机构，')
              }}
            </p>
            <p>
              {{ $t('提供从赛事运营、赛事执行、参赛数据统计&分析及赛事直播、后勤保障等线上+线下一站式服务支撑，') }}
            </p>
            <p>{{ $t('服务已达34个省级行政区，90000+场次比赛') }}</p>
          </div>
        </div>
        <div class="look-btn" id="look" @click="serviceDetail">{{ $t('查看服务流程') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Organizing',
  components: {},
  mounted() {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    serviceDetail() {
      this.$router.push({
        name: 'Service',
        params: {
          index: 0,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  position: relative;
  top: -71px;
}
.container {
  width: 100%;
  height: 460px;
  background-image: url('../../../assets/organizing.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
.content {
  width: 1200px;
  height: 80%;
  margin: 0 auto;
  color: white;
  position: relative;
  overflow: hidden;
}
.content h1 {
  color: white;
  font-weight: bold;
  font-size: 40px;
  padding-top: 60px;
}
.content h2 {
  color: white;
  font-weight: bold;
}
.content p {
  font-weight: bold;
  font-size: 14px;
}
.txt-box {
  position: absolute;
  left: 0;
  top: -400px;
  transition: 0.5s;
}
.content .txton {
  left: 0;
  transition: 0.5s;
  top: 0px;
}
.look-btn {
  width: 200px;
  height: 60px;
  border: 1px solid #fff;
  border-radius: 60px;
  position: absolute;
  right: 0px;
  bottom: -150px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  transition: 0.5s;
  cursor: pointer;
  opacity: 0.7;
}
.look-btn:hover {
  opacity: 1;
  // border: 1px solid #b01f23;
}
.content .on {
  right: 0;
  transition: 0.5s;
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/components/Organizing.vue